"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var MakeActions = _interopRequireWildcard(require("crm_data/actions/MakeActions"));

var ActionVerbs = _interopRequireWildcard(require("crm_data/actions/ActionVerbs"));

function _default(namespace) {
  return Object.assign(MakeActions.makeAsyncActionTypes(namespace, ActionVerbs.FETCH), {
    MOVED: namespace + "_RESULT_MOVED",
    EXPIRED: namespace + "_RESULT_EXPIRED",
    VIEW_UPDATED: namespace + "_VIEW_UPDATED"
  });
}

module.exports = exports.default;